/* LED-BOX — actualizarea codului de produs si a codului de bare la schimbarea variantei.

   Tema "Local" randeaza `data-js-product-sku` si `data-js-product-barcode`, dar
   JavaScript-ul ei actualizeaza doar campurile de pret. Rezultatul: clientul care
   alege alta varianta vede pretul corect si codul primei variante.

   Corectia asculta schimbarea variantei din formular si rescrie cele doua campuri,
   pastrand prefixele traduse ("SKU: ", "ISBN: ") asa cum le-a randat tema.
   Daca ceva nu merge, nu atinge DOM-ul si lasa pagina exact cum era. */
(function () {
  'use strict';

  function init() {
    var form = document.querySelector('form[action*="/cart/add"]');
    var skuEl = document.querySelector('[data-js-product-sku]');
    var barEl = document.querySelector('[data-js-product-barcode]');
    if (!form || (!skuEl && !barEl)) return;

    var idInput = form.querySelector('[name="id"]');
    if (!idInput) return;

    var data = null;
    var prefixes = null;

    function prefixOf(el, value) {
      var t = (el.textContent || '').trim();
      if (!value) return t ? t + ' ' : '';
      var i = t.lastIndexOf(value);
      return i > 0 ? t.slice(0, i) : (t ? t.replace(value, '') : '');
    }

    function apply(variant) {
      if (!variant) return;
      if (skuEl) {
        skuEl.textContent = variant.sku ? prefixes.sku + variant.sku : '';
      }
      if (barEl) {
        barEl.textContent = variant.barcode ? prefixes.barcode + variant.barcode : '';
      }
    }

    function current() {
      if (!data) return null;
      var id = String(idInput.value);
      for (var i = 0; i < data.variants.length; i++) {
        if (String(data.variants[i].id) === id) return data.variants[i];
      }
      return null;
    }

    function load() {
      return fetch(window.location.pathname + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          data = p;
          var v = current();
          prefixes = {
            sku: skuEl ? prefixOf(skuEl, v && v.sku) : '',
            barcode: barEl ? prefixOf(barEl, v && v.barcode) : ''
          };
        })
        .catch(function () { data = null; });
    }

    function onChange() {
      if (!data) {
        load().then(function () { apply(current()); });
      } else {
        apply(current());
      }
    }

    load();

    form.addEventListener('change', function () { setTimeout(onChange, 60); });
    document.addEventListener('click', function (ev) {
      if (ev.target.closest('product-variants, .product-variants')) setTimeout(onChange, 140);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
